import { useMemo } from 'react';

import { useRetailerSettings } from './useRetailerSettings';

import { RetailerDocumentType } from '~/core/models';

const INSTALL_SUFFIX = /\[Install]$/i;
const PO_SUFFIX = /\[Product Only]$/i;

/**
 * retailer documents are elements from the retailerSettings API results, identified by "documentType"
 * @param documentType the document type to match
 * @param isInstalled whether the current product is an installed product or "product only", defaults to true
 */
export const useRetailerDocument = (
  documentType: RetailerDocumentType,
  isInstalled = true
): string | undefined => {
  const { retailerSettings } = useRetailerSettings();

  return useMemo<string | undefined>(() => {
    const doc = retailerSettings?.documents?.find(
      (document) =>
        document.type === documentType ||
        !!(
          document.type.match(documentType) &&
          document.type.match(isInstalled ? INSTALL_SUFFIX : PO_SUFFIX)
        )
    );

    return doc?.url ?? undefined;
  }, [isInstalled, retailerSettings, documentType]);
};
